import { render, staticRenderFns } from "./LinhaDeDados.vue?vue&type=template&id=3d6573c4&scoped=true"
import script from "./LinhaDeDados.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeDados.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeDados.vue?vue&type=style&index=0&id=3d6573c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6573c4",
  null
  
)

export default component.exports